module.exports = __webpack_public_path__ + "static/media/review-1.dd704905.png";